module.exports = __webpack_public_path__ + "static/pittsburgh-582ce13e3f980b03f2ad3c799b0b7ad1.jpg";